import { composeIO } from 'react-compose-io'
import { modalClassificarPedidosIO } from './ModalClassificarPedidos.IO'
import ModalClassificarPedidosView from './ModalClassificarPedidos.View'

export const ModalClassificarPedidos = composeIO(ModalClassificarPedidosView, modalClassificarPedidosIO)
